// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnifiedYourProfileAboutForm = require("./UnifiedYourProfileAboutForm.bs.js");
let UnifiedYourProfileAboutSettingsQuery_graphql = require("../../__generated__/UnifiedYourProfileAboutSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedYourProfileAboutSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfileAboutSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfileAboutSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedYourProfileAboutSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedYourProfileAboutSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedYourProfileAboutSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedYourProfileAboutSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedYourProfileAboutSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedYourProfileAboutSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedYourProfileAboutSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
        title: "About You",
        rootName: "Your Profile",
        rootUrl: "/account/profile",
        url: "/account/profile/about"
      }),
      JsxRuntime.jsx(UnifiedYourProfileAboutForm.make, {
        agent: match.currentlyLoggedInAgent.fragmentRefs
      })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = UnifiedYourProfileAboutSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
